import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getOutStanding(params) {
	return clientSupplier.get("api-supplier/po-outstanding/data", {
		params: params,
	});
}

function detailOutstanding(params) {
	return clientSupplier.get("api-supplier/po-outstanding/detail", {
		params: {
			po_code : params
		},
	});
}

function exportOutStanging(params) {
	return clientSupplier.get("api-supplier/po-outstanding/export", {
		params: params,
	});
}

export default {
	getOutStanding,
	detailOutstanding,
	exportOutStanging
};